export const metersToNauticalMiles = (meters, dec = 2) => {
    if (!meters) {
        return meters;
    }
    const factor = 1852;
    const nauticalMiles = meters / factor;
    return parseFloat(nauticalMiles.toFixed(dec));
};

export const nauticalMilesToMeters = (nauticalMiles, dec = 2) => {
    if (!nauticalMiles) {
        return nauticalMiles;
    }
    const factor = 1852;
    const meters = nauticalMiles * factor;
    return parseFloat(meters.toFixed(dec));
};

export const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const toggleStringInArray = (arr, strings) => {
    strings.forEach((str) => {
        const index = arr.indexOf(str);
        if (index === -1) {
            arr.push(str);
        } else {
            arr.splice(index, 1);
        }
    });
    return arr;
};

export const metersToKilometers = (meters, dec = 2) => {
    if (!meters) {
        return meters;
    }
    const kilometers = meters / 1000;
    return parseFloat(kilometers.toFixed(dec));
};

export const squareMetersToKilometers = (meters, dec = 2) => {
    if (!meters) {
        return meters;
    }
    const kilometers = meters / 1000000;
    return parseFloat(kilometers.toFixed(dec));
};
